<nackle-quiz-questionnaire [promotionId] = "promotionId" [enableContent] = "enableContent" *ngIf="promotionId" 
[isAdmin] = "isAdmin" [culture] = "culture" [attemptUserId] = "attemptUserId" ></nackle-quiz-questionnaire>

<div class="modal-footer">    
    <button class="btn btn-default" type="button" (click)="cancel()">Cancel</button>
</div>